import { render, staticRenderFns } from "./AdminSourcesTable.vue?vue&type=template&id=eb38280a&scoped=true"
import script from "./AdminSourcesTable.vue?vue&type=script&lang=js"
export * from "./AdminSourcesTable.vue?vue&type=script&lang=js"
import style0 from "./AdminSourcesTable.vue?vue&type=style&index=0&id=eb38280a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb38280a",
  null
  
)

export default component.exports